import { useState } from "react";
const faqs = ["Is client data and payment security bank-level?", "How fast are payouts settled?", "What is the total setup time?", "Does this integrate with Square, Vagaro, or Booker?", "What training is required for my staff?", "How do refunds and unused packages work under the new 7-day law?", "How reliable are the QR codes in humid or low-light spa rooms?", "What is the pricing model?"];
export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const toggle = (i: number) => {
    setOpenIndex(openIndex === i ? null : i);
  };
  return <section id="faq" style={{
    backgroundColor: "rgb(255, 252, 247)",
    backgroundPosition: "0% 0%",
    backgroundRepeat: "repeat",
    color: "rgb(42, 45, 43)",
    fontFamily: 'ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
    paddingTop: "96px",
    paddingBottom: "96px"
  }}>
      <div className="page-container">
        <div className="flex flex-col items-center">
          <p style={{
          color: "#C8985C",
          fontSize: "12px",
          fontWeight: "500",
          lineHeight: "16px",
          letterSpacing: "0.6px",
          textTransform: "uppercase",
          textAlign: "center",
          marginBottom: "8px",
          fontFamily: 'ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"'
        }}>
            OPERATIONAL CLARIFICATIONS
          </p>
          <h2 style={{
          color: "rgb(31, 58, 46)",
          fontFamily: 'ui-serif, Georgia, Cambria, "Times New Roman", Times, serif',
          fontSize: "36px",
          fontWeight: "400",
          lineHeight: "40px",
          textAlign: "center",
          marginBottom: "44px"
        }}>
            Frequently Asked Questions
          </h2>

          <div className="w-full" style={{
          maxWidth: "760px",
          backgroundColor: "rgb(245, 242, 236)",
          borderRadius: "16px",
          border: "1px solid rgba(31, 58, 46, 0.08)",
          boxShadow: "0 4px 24px 0 rgba(31, 58, 46, 0.07)",
          overflow: "hidden"
        }}>
            {faqs.map((question, i) => <div key={i} data-index={i}>
                {i > 0 && <div style={{
              height: "1px",
              backgroundColor: "rgba(31, 58, 46, 0.12)",
              marginLeft: "24px",
              marginRight: "24px"
            }} />}
                <button onClick={() => toggle(i)} className="w-full flex items-center justify-between cursor-pointer transition-colors duration-150" style={{
              color: "rgb(31, 58, 46)",
              fontFamily: 'ui-serif, Georgia, Cambria, "Times New Roman", Times, serif',
              fontSize: "16px",
              fontWeight: "600",
              lineHeight: "24px",
              borderRadius: "8.4px",
              border: "0px solid oklch(0.69 0.04 165 / 0.25)",
              padding: "16px 24px",
              textAlign: "left",
              backgroundColor: "transparent",
              outline: "none"
            }}>
                  <span style={{
                flex: 1,
                textAlign: "left"
              }}>{question}</span>
                  <span className="ml-4 flex-shrink-0 transition-transform duration-200" style={{
                transform: openIndex === i ? "rotate(180deg)" : "rotate(0deg)",
                color: "rgb(31, 58, 46)"
              }}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="m6 9 6 6 6-6"></path>
                    </svg>
                  </span>
                </button>
                {openIndex === i && <div style={{
              padding: "0px 24px 16px 24px",
              color: "rgba(42, 45, 43, 0.75)",
              fontFamily: 'ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
              fontSize: "14px",
              lineHeight: "22px"
            }}>
                    {question === "Is client data and payment security bank-level?" ? "Yes, absolutely. All payments are processed through a fully PCI-DSS Level 1 compliant gateway. PrepayQR never stores raw credit card details. Clients pay securely using native biometric tokens (Apple Pay / Google Pay) or encrypted credit card entry." : question === "How fast are payouts settled?" ? "We settle payouts on a daily basis. Funds processed through PrepayQR are automatically batched and transferred directly to your connected bank account within 24 hours of the transaction." : question === "What is the total setup time?" ? "The digital configuration takes less than 60 seconds during soft‑enrollment. Once qualified, you can download your custom table QR codes instantly. Physical gold‑rimmed cards are shipped to your spa and arrive in 3‑5 business days." : question === "Does this integrate with Square, Vagaro, or Booker?" ? "Yes. PrepayQR is built to work seamlessly alongside your existing software. We act as a high-velocity checkout overlay at the massage table, and we provide automatic integrations to sync package balances and sessions directly with your current scheduling tool." : question === "What is the pricing model?" ? "We believe in pure performance-based pricing. There are no setup fees, no licensing fees, and no monthly contracts. We only charge a flat 3% commission on processed prepaid transactions. If your clients don't buy, you pay nothing." : "PrepayQR includes a structured 3-minute micro-training that eliminates manual package deduction errors entirely. This process keeps your books clean and makes your therapists look like pros from day one without burdening them with awkward sales pitches."}
                  </div>}
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}